import { render } from "./custlogin.vue?vue&type=template&id=1bd1d420"
import script from "./custlogin.vue?vue&type=script&lang=js"
export * from "./custlogin.vue?vue&type=script&lang=js"

import "./custlogin.vue?vue&type=style&index=0&id=1bd1d420&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__